import { createContext } from "react";
const DeviceManagerContext = createContext(void 0);
var context_default = DeviceManagerContext;
export {
  context_default as default
};
